import { render, staticRenderFns } from "./LedgerAccountWisePrintReport.vue?vue&type=template&id=2140ed54&scoped=true&"
import script from "./LedgerAccountWisePrintReport.vue?vue&type=script&lang=js&"
export * from "./LedgerAccountWisePrintReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2140ed54",
  null
  
)

export default component.exports